/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-default";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = "en";
export const localeOptions = [
  { id: "en", name: "English - LTR", direction: "ltr" },
  { id: "es", name: "Español", direction: "ltr" },
  { id: "enrtl", name: "English - RTL", direction: "rtl" },
];

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

export const adminRoot = process.env.REACT_APP_ADMIN_ROOT;
export const appRoot = process.env.REACT_APP_APP_ROOT;
export const buyUrl = process.env.REACT_APP_BUY_URL;
export const searchPath = `${adminRoot}/#`;
export const servicePath = process.env.REACT_APP_SERVICE_PATH;

export const themeColorStorageKey = "__theme_selected_color";
export const isMultiColorActive = false;
export const defaultColor = "light.redruby";
export const isDarkSwitchActive = true;
export const defaultDirection = "ltr";
export const themeRadiusStorageKey = "__theme_radius";
export const isAuthGuardActive = true;
export const colors = [
  "bluenavy",
  "blueyale",
  "blueolympic",
  "greenmoss",
  "greenlime",
  "purplemonster",
  "orangecarrot",
  "redruby",
  "yellowgranola",
  "greysteel",
];

export const merchantRoles = [
  { value: "Developer", label: "Developer" },
  { value: "Operations", label: "Operations" },
];

export const adminRoles = [
  { value: "Support", label: "Support" },
  // {value: 'AdminOperations', label: 'AdminOperations'},
  { value: "Operations", label: "Operations" },
  { value: "Admin", label: "Admin" },
  { value: "Approver", label: "Approver" },
  { value: "Authorizer", label: "Authorizer" },
];

// export const BASE_URL = "http://icard-api.smadeandsmight.com/api";
// export const BASE_URL =  "https://localhost:44331/api"
// export const BASE_URL = "https://localhost:5001/api"
const BASE = "https://app-service.icadpay.com";
// export const BASE_URL = "https://localhost:5001/api"
// const BASE = `https://app-service.icadpay.com`;
// const BASE = "https://staging-api.icadpay.com";
export const BASE_URL = `${BASE}/api`;
// export const BASE_TEST_URL = `${LIVEBASE}/api`;
// const BASE_AUTH_TEST = `${BASE_TEST_URL}/Auth`
const BASE_AUTH = `${BASE_URL}/Auth`;
const BASE_ADMIN = `${BASE_URL}/Admin`;
const BASE_MERCHANT = `${BASE_URL}/Merchant`;
const BASE_SETTINGS = `${BASE_URL}/Settings`;
const BASE_REPORT = `${BASE_URL}/Report`;
const BASE_PAYMENT = `${BASE_URL}/Payment`;

export const QUERY_DEMO = `${BASE_URL}/query-status`;

export const GET_ROLE = `${BASE_URL}/Roles`;

export const MERCHANT_TYPE_LIST = `${BASE_MERCHANT}/merchantCategory`;

export const MERCHANTS_LIST = `${BASE_ADMIN}/allMerchants`;
export const ADD_MERCHANT_BANK = `${BASE_ADMIN}/addBankAccount`;
export const UPDATE_MERCHANT_BANK = `${BASE_ADMIN}/updateBankAccount`;
export const GET_ALL_MERCHANTS = `${BASE_SETTINGS}/GetAllMerchant`;
export const MERCHANTS_FEE_LIST = `${BASE_ADMIN}/merchantCharges`;
export const MERCHANTS_ACTIVE_LIST = `${BASE_ADMIN}/activeMerchants`;
export const MERCHANTS_SUSPENDED_LIST = `${BASE_ADMIN}/suspendedMerchants`;
export const MERCHANTS_DEACTIVATED_LIST = `${BASE_ADMIN}/DeactivatedMerchants`;
export const MERCHANTS_LIST_PENDING = `${BASE_ADMIN}/pendingMerchants`;
export const MERCHANTS_LIST_AUTH = `${BASE_ADMIN}/pendingApprovalMerchants`;
export const MERCHANTS_LIST_AUTH_PENDING = `${BASE_ADMIN}/pendingAuthorizationMerchants`;
export const ADMIN_USERS_LIST = `${BASE_ADMIN}/allAdmin`;
export const CONFIRM_MERCHANT = `${BASE_ADMIN}/ConfirmMerchant`;
export const CONFIRM_MERCHANT_TWO = `${BASE_ADMIN}/AuthorizeMerchant`;
export const VIEW_DOCUMENT = `${BASE_ADMIN}/document`;
export const ACTIVATE_USER = `${BASE_ADMIN}/activateUser`;
export const DEACTIVATE_USER = `${BASE_ADMIN}/deactivateUser`;
export const MERCHANT_ACTIVATE_USER = `${BASE_MERCHANT}/activateUser`;
export const MERCHANT_DEACTIVATE_USER = `${BASE_MERCHANT}/deactivateUser`;
export const SUSPEND_USER = `${BASE_ADMIN}/suspendUser`;
export const REMITA_SETTLEMENT = `${BASE_ADMIN}/allMerchantSettlements`;
export const MERCHANT_PROFILE = `${BASE_MERCHANT}/merchantProfile`;
export const DELETE_MERCHANT_BANKS = `${BASE_MERCHANT}/DeleteBankAccount`;
export const UPDATE_MERCHANT_PROFILE = `${BASE_MERCHANT}/updateMerchantProfile`;
export const MERCHANT_BANKS = `${BASE_MERCHANT}/merchantBank`;
export const GET_ALL_MERCHANTS_BANK = `${BASE_MERCHANT}/GetAllMerchantBanks`;
export const GET_MERCHANT_BANK_DETAILS = `${BASE_MERCHANT}/GetMerchantBankDetails`;
export const NEW_MERCHANT_BANKS = `${BASE_MERCHANT}/addBankAccount`;
export const ENCRYPTION_KEYS = `${BASE_MERCHANT}/encriptionkeys`;
export const NEW_SUB_ACCOUNTS = `${BASE_MERCHANT}/sub/newMerchantSub`;
export const DELETE_SUB_ACCOUNTS = `${BASE_URL}/Merchant/sub/deleteMerchantSub`;
export const MERCHANT_SUB_ACCOUNTS = `${BASE_MERCHANT}/allMerchantAccounts`;
export const USERS_LIST = `${BASE_MERCHANT}/allUsers`;
export const CUSTOMER_LIST = `${BASE_MERCHANT}/allCustomers`;
export const UPLOAD_DOCUMENT = `${BASE_MERCHANT}/uploadDocument`;
export const TRANSACTIONS_LIST = `${BASE_MERCHANT}/allTransactions`;
export const FAILED_TRANSACTIONS_LIST = `${BASE_MERCHANT}/failedTransactions`;
export const INVOICE_LIST = `${BASE_MERCHANT}/GetInvoivce`;
export const TRANSACTIONFILTER = `${BASE_MERCHANT}/transactionBySpecificChannel`;
export const INVOICE_DETAILS = `${BASE_MERCHANT}/GetInvoivceById`;
export const ACTIVATE_DEACTIVATE_SUB_ACC = `${BASE_MERCHANT}/sub/DeactivateSubMerchant`;

export const TRANSACTION_ITEM = `${BASE_MERCHANT}/singleTransaction`;
export const WALLET_HISTORY = `${BASE_MERCHANT}/walletHistory`;
export const WALLET_BALANCE = `${BASE_MERCHANT}/walletBalance`;
export const WALLET_TOPUP = `${BASE_MERCHANT}/walletTopup`;
export const CHANGE_PIN = `${BASE_MERCHANT}/ChangePin`;
export const CREATE_PIN = `${BASE_MERCHANT}/SetPin`;
export const ADD_HOOKS = `${BASE_MERCHANT}/webhooks`;

const BASE_ALT_BILLER = `${BASE_URL}/AltBiller`;
export const LOGO_URL = `${BASE}/mlogo/`;
export const LIST_BILL_CAT = `${BASE_ALT_BILLER}/servicesCategory`;
export const LIST_BILL_SERVICE = `${BASE_ALT_BILLER}/serviceByIdentifier`;
export const LIST_BILL_SERVICE_VARIETIES = `${BASE_ALT_BILLER}/serviceVariety`;
export const INIT_PAY = `${BASE_ALT_BILLER}/initiatePayment`;
export const VERIFY_CUSTOMER = `${BASE_ALT_BILLER}/customerValidation`;
export const BILLS_TRANSACTIONS = `${BASE_ALT_BILLER}/allBillspayment`;
export const CREATE_INVOICE = `${BASE_MERCHANT}/CreateInvoivce`;
export const GET_VALUE = `${BASE_ALT_BILLER}/getValue`;

export const ACCOUNT_SIGNUP = `${BASE_AUTH}/merchant/register`;
export const TEST_ACCOUNT_SIGNUP = `${BASE_AUTH}/merchant/TestRegisterMerchant`;
export const LOGIN_URL = `${BASE_AUTH}/authenticate`;
export const NEW_SUB_USER = `${BASE_AUTH}/createUser`;
// export const APP_TWO_FA_AUTH = `${BASE_AUTH}/appTwoFaAuthorize`;
export const APP_TWO_FA_AUTH = `${BASE_AUTH}/twoFaAuthorize`;
export const SMS_TWO_FA_AUTH = `${BASE_AUTH}/SmsTwoFaAuthorize`;
export const REQ_TWO_FA = `${BASE_AUTH}/requestEnableTwoFA`;
export const ENABLE_TWO_FA = `${BASE_AUTH}/enableTwoFA`;
export const DISABLE_TWO_FA = `${BASE_AUTH}/disableTwoFA`;
export const DISABLE_TWO_FA_REQ = `${BASE_AUTH}/disableTwoAltFA`;
export const DELETE_USER = `${BASE_AUTH}/deleteUserAccount`;
export const REFRESH_TOKEN = `${BASE_AUTH}/refresh-token`;
export const RESEND_2FA_LOGIN_TOKEN = `${BASE_AUTH}/resendOTP`;

export const EMAIL_CONFIRM = `${BASE_AUTH}/ConfirmEmail`;
export const FORGOT_PASSWORD = `${BASE_AUTH}/ResetPasswordRequest`;
export const PASSWORD_RESET = `${BASE_AUTH}/ResetPassword`;
export const CHANGE_PASS = `${BASE_AUTH}/ChangePassword`;
export const APP_SETTINGS = `${BASE_URL}/register`;

export const ACCOUNT_QUERY = `${BASE_PAYMENT}/accountEnquiry`;
export const FUND_TRANSFER = `${BASE_PAYMENT}/newPayment`;

export const LINE_CHART = `${BASE_REPORT}/transactionSeries`;
export const UN_SUM = `${BASE_REPORT}/transactionSum`;
export const SETTLED_SUM = `${BASE_REPORT}/transactionSumSettled`;
export const CARD_INCOME = `${BASE_REPORT}/transactionByChannel`;

export const GET_BANKS = `${BASE_SETTINGS}/banks`;

export const QR_PAY = `${BASE_URL}/payWithQr`;

export const DOWNLOAD_TRANSACTION_REPORT = `${BASE_MERCHANT}/downloadtransactionlist`;

export const GET_MERCHANT_AUDIT_TRAIL = `${BASE_MERCHANT}/allAuditLogs`;

export const GET_SUPPORT_TICKETS = `${BASE_MERCHANT}/allTickets`;

export const ADD_SUPPORT_TICKET = `${BASE_MERCHANT}/addTicket`;

export const GET_COMMENT_BY_TICKETID = `${BASE_MERCHANT}/getCommentsByTicketId`;

export const ADD_COMMENT = `${BASE_MERCHANT}/addComment`;

export const GET_TICKET_STATUSES = `${BASE_MERCHANT}/statuses`;

export const UPDATE_TICKET_STATUS = `${BASE_MERCHANT}/UpdateTicketStatus`;

export const GET_SETTLMENT_SUMMARY = `${BASE_REPORT}/DailySettlementSummary`;

export const GET_SETTLEMENT_SUMMARY_BY_ID = `${BASE_REPORT}/DailySettlementSummary`;

// export const INVOICEPAY = `${BASE_MERCHANT}/CreateInvoivce`;
